var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-10 pt-10 text-center"},[_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.$t("browserNotSupported.label")))]),_c('div',{staticClass:"headline mt-10"},[_vm._v(_vm._s(_vm.$t("browserNotSupported.text")))])])}
var staticRenderFns = []

export { render, staticRenderFns }